import { useCallback, useEffect, useState } from 'react';
// @mui
import Container from '@mui/material/Container';
import Card from '@mui/material/Card';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hook';
import { useParams } from 'src/routes/hook/use-params';
// components
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import { useSnackbar } from 'src/components/snackbar';
// types
import { LoSam, LoSamApi } from 'src/types/losam';
// hooks 
import { useLoSam } from '../hooks/use-losam';
// sections
import LoSamNewEditForm from '../lo-sam/lo-sam-new-edit-form';

// ----------------------------------------------------------------------

export default function EditLoSamView() {
  const settings = useSettingsContext();
  const router = useRouter();
  const { id } = useParams() as { id: string };
  const { enqueueSnackbar } = useSnackbar();

  const { getLoSamById,editLoSam } = useLoSam();
  const [current, setCurrent] = useState<LoSam | null>(null);

  useEffect(() => {
    const fetch = async () => {
      if (!id) return;
      try {
        const rsp = await getLoSamById(Number(id));
        if (rsp.messCode === 1 && rsp.oneItem) {
          setCurrent(rsp.oneItem as LoSam);
        }
      } catch (error) {
        console.error('Error fetching LoSam:', error);
        enqueueSnackbar('Không thể tải thông tin lô sâm', { variant: 'error' });
      }
    };
    fetch();
  }, [getLoSamById, id, enqueueSnackbar]);

  const handleClose = useCallback(() => {
    router.push(paths.dashboard.losam.root);
  }, [router]);  
  const handleSave = useCallback(
    async (data: Partial<LoSamApi>, file?: File) => {
      try {
        setLoading(true);
        // Ensure trangThai is set from is_public mapping (1 active, 2 inactive)
        const payload: LoSamApi = {
          ...data,
          trangThai: data.trangThai ?? 1,
          vuonTrong_ID: data.vuonTrong_ID || 0,
        } as LoSamApi;

        // NOTE: Requires data.vuonTrong_ID to be present
        const response = await editLoSam(payload, file);
 
        if (response.messCode === 1) {
          enqueueSnackbar('Tạo lô sâm thành công!', { variant: 'success' });
          router.push(paths.dashboard.losam.root);
        } else {
          enqueueSnackbar(response.message || 'Có lỗi xảy ra khi tạo lô sâm', { variant: 'error' });
        }
      } catch (error) {
        console.error('Error creating LoSam:', error);
        enqueueSnackbar('Có lỗi xảy ra khi tạo lô sâm', { variant: 'error' });
      } finally {
        setLoading(false);
      }
    },
    [enqueueSnackbar, router, editLoSam]
  );

  if (!current) {
    return null; // or loading spinner
  }

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Chỉnh sửa lô sâm"
        links={[
          { name: 'Dashboard', href: paths.dashboard.root },
          { name: 'Lô sâm', href: paths.dashboard.losam.root },
          { name: 'Chỉnh sửa' },
        ]}
        sx={{ mb: { xs: 3, md: 5 } }}
      />

        <LoSamNewEditForm currentLoSam={current} onClose={handleClose} onSave={handleSave} />
    </Container>
  );
}
function setLoading(arg0: boolean) {
  throw new Error('Function not implemented.');
}

